"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _disposeAll = _interopRequireDefault(require("./disposeAll"));

/**
 * Utility class for handling various disposable things like timeouts, disposable functions.
 *
 * @class DisposableManager
 * @constructor
 */
var DisposableManager =
/*#__PURE__*/
function () {
  function DisposableManager() {
    Object.defineProperty(this, "disposables", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: []
    });
  }

  var _proto = DisposableManager.prototype;

  /**
   * Add one or more dispose functions to the DisposableManager
   *
   * @method add
   * @param disposable
   * @returns void
   */
  _proto.add = function add() {
    var _disposables;

    (_disposables = this.disposables).push.apply(_disposables, arguments);
  };
  /**
   * Disposes all registered objects
   *
   * @method dispose
   */


  _proto.dispose = function dispose() {
    (0, _disposeAll.default)(this.disposables);
  };

  return DisposableManager;
}();

exports.default = DisposableManager;